module.exports = function UpdateTopicDeltaRequest(path, id, bytes) {
    this.path = path;
    this.id = id;
    this.bytes = bytes;
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/update-topic/update-topic-delta-request.js
// module id = 499
// module chunks = 1